import React from 'react';

const PlayCircleIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_28131_101416)">
      <path
        d="M10.0013 18.3307C14.6037 18.3307 18.3346 14.5998 18.3346 9.9974C18.3346 5.39502 14.6037 1.66406 10.0013 1.66406C5.39893 1.66406 1.66797 5.39502 1.66797 9.9974C1.66797 14.5998 5.39893 18.3307 10.0013 18.3307Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91797 7.46851C7.91797 7.07077 7.91797 6.8719 8.00109 6.76088C8.07352 6.66413 8.1844 6.60359 8.30495 6.59498C8.44329 6.5851 8.61057 6.69264 8.94514 6.90772L12.879 9.43661C13.1693 9.62325 13.3145 9.71656 13.3646 9.83522C13.4084 9.9389 13.4084 10.0559 13.3646 10.1596C13.3145 10.2782 13.1693 10.3715 12.879 10.5582L8.94514 13.0871C8.61057 13.3022 8.44329 13.4097 8.30495 13.3998C8.1844 13.3912 8.07352 13.3307 8.00109 13.2339C7.91797 13.1229 7.91797 12.924 7.91797 12.5263V7.46851Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_28131_101416">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PlayCircleIcon;
